import React, {Component} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../CSS/LoginPage.css';
import LoginForm from './LoginForm.js';
import 'whatwg-fetch';
//import Promise from 'promise-polyfill';
import AuthService from '../utils/AuthService.js';
import { Switch, Route, Link } from 'react-router-dom'
import logo from '../images/logo.png'

class CreateAccount extends Component {
  constructor(props) {
    super(props);
    this.Auth = new AuthService()
    this.state = {
      email: "",
      password: "",
      passwordRepeat: "",
      error: null
    };
  }

  validateForm(){
    return this.state.email.length > 0 && this.state.password.length > 0 && this.state.password == this.state.passwordRepeat;
  }

  handleChange = event => {
      this.setState({
        [event.target.id]: event.target.value
      });
  }
  handleSubmit = event => {
    event.preventDefault()
    // console.log(JSON.stringify({
    //   user:{
    //   email: this.state.email,
    //   password: this.state.password,
    //   }
    // }))
    this.Auth.createAccount(this.state.email,this.state.password)
          .then(res =>{
            if(res.errors){
              this.setState({
                error: res.errors
              })
            }
            else {
              localStorage.setItem('id_token', res.auth_token) // Setting the token in localStorage
              localStorage.setItem('customer_id', res.id)
              window.location.href = '../'
            }
          })
          .catch(err =>{
              alert(err);
          })


  }
    render(){
      return (
        <div className="container-fluid vertical-align">
          <div className="row">
            <div className="offset-lg-2 col-lg-8 content">
              <div className="card-body text-center bg-dark">
                <img className="logo-login" alt ="logo" src={logo}></img>
                <h5>{this.state.error}</h5>
                <form onSubmit={this.handleSubmit}>
                  <div className="form-group">
                    <input className="form-control form-control-md mb-2" type="email" id="email" value={this.state.email} onChange={this.handleChange} placeholder="Email"></input>
                    <input className="form-control form-control-md mb-2" type="password" id="password" value={this.state.password} onChange={this.handleChange} placeholder="Password"></input>
                    <input className="form-control form-control-md" type="password" id="passwordRepeat" value={this.state.passwordRepeat} onChange={this.handleChange} placeholder="Password"></input>
                  </div>
                  <div className="form-group">
                    <button className="btn btn-success btn-block text-center" type="submit" disabled={!this.validateForm()}>Create Account</button>
                  </div>
                </form>
                <div className="row">
                  <div className="col">
                      <Link to='/login' replace>
                      <button className="btn btn-primary btn-sm float-left" type="button">Login</button>
                      </Link>
                    <button className="btn btn-primary btn-sm float-right" type="button">Explore as Guest
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>-
        </div>
      )
    }
}
export default CreateAccount;



// WEBPACK FOOTER //
// ./src/Components/CreateAccount.js